<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb44></breadcrumb44>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar1></sidebar1>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row ml-md-3" id="appointment_container">
                <div class="col-md-12">
                  <!-- <h3 class="mb-3 mt-2">My Visits</h3> -->
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0" style="border: none;">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th style="background-color: #F8F8F8;" class="text-left">Doctor Name</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Date</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Encounter Time</th>
                                    <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in my_appointments" :key="item.id"
                                    v-show="setPaginate($index)">
                                    <td class="text-left">
                                      <h2 class="table-avatar">
                                        <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img
                                            class="avatar-img rounded-circle" v-bind:src="item.image
                                                ? config.base_url_for_Image +
                                                item.image
                                                : loadImg('Patient Profile.svg')
                                              " alt="User Image" /></a>
                                        <a href="javascript:void(0);">{{
                                          item.practitioner_name
                                        }}</a>
                                      </h2>
                                    </td>
                                    <td class="text-left">
                                      {{ convertDate(item.encounter_date) }}
                                    </td>
                                    <td class="text-left">
                                      {{ formatTime(item.encounter_time) }}
                                    </td>
                                    <td class="text-left">
                                      <div class="table-action">
                                        <a href="javascript:void(0);" @click="downloadPDF(item.name)"
                                          class="btn btn-sm bg-info-light">
                                          <i class="fas fa-file-pdf"></i> DownLoad
                                          Pdf
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="my_appointments.length === 0 && !showspinner
                                " class="No_data">
                                No Encounter Found
                              </h5>
                            </div>
                            <!-- pagination start -->
                            <div id="pagination" v-if="my_appointments.length > 10">
                              <ul class="pagination justify-content-center">

                                <!-- "Previous" Button -->
                                <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                                  <a href="#" class="page-link" aria-label="Previous"
                                    @click.prevent="updateAppointmentCurrent(current - 1)">
                                    Previous
                                  </a>
                                </li>
                                <!-- Pagination Links (Display 5 at a time) -->
                                <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                                  'page-item',
                                  current === page_index ? 'active' : ''
                                ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                                  <a href="#" class="page-link" @click.prevent="updateAppointmentCurrent(page_index)">
                                    {{ page_index }}
                                  </a>
                                </li>

                                <!-- "Next" Button -->
                                <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                                  ">
                                  <a href="#" class="page-link" aria-label="Next"
                                    @click.prevent="updateAppointmentCurrent(current + 1)">
                                    Next
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <!-- pagination end -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      config: config,
      total_appointment: "",
      todays_appointment: "",
      appointments: "",
      my_appointments: [],
      closed_appointments: [],
      showspinner: true,

      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },


  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_patient_encounter_data_for_patient();
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),

    totalPages() {
      return Math.ceil(this.my_appointments.length / this.paginate);
    },
  },
  methods: {

    updateAppointmentCurrent(i) {
      this.current = i;
      document.getElementById("appointment_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    /* Get Open Patient Encounter List */
    downloadPDF(id) {
  let data = {
    encounter_id: id,
  };
  CommonApi.post_data("sahaj.api.generate_encounter_pdf", data).then((res) => {
    const binaryData = atob(res.data);
    const arrayBuffer = new Uint8Array(binaryData.length);
    for (let i = 0; i < binaryData.length; i++) {
      arrayBuffer[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url);
  });
},

    /* Get Open Patient Encounter List */
    get_patient_encounter_data_for_patient() {
      let data = {
        patient: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.api.get_patient_encounter_data_for_patient",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.my_appointments = res.data;
          this.paginate_total = Math.ceil(
            this.my_appointments.length / this.paginate
          );
        }
      });
    },

    /* Get Date */
    // convertDate(str) {
    //   if (str === null || str === "") {
    //     return "";
    //   } else {
    //     var date = new Date(str),
    //       mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //       day = ("0" + date.getDate()).slice(-2);
    //     return [day, mnth, date.getFullYear()].join("-");
    //   }
    // },
    convertDate(str) {
  if (str === null || str === "") {
    return "";
  } else {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    return [day, mnth, year].join("-");
  }
},

    formatTime(time) {
    if (!time) {
      return "";
    }
    const timeParts = time.split(":");
    if (timeParts.length !== 3) {
      return "";
    }
    const hours = parseInt(timeParts[0]);
    const minutes = timeParts[1];
    const amOrPm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${formattedHours}:${minutes} ${amOrPm}`;
  },
  },
};
</script>
<style scoped>
table {
    border-collapse: collapse;
    width: 100%;
    border-top: 1px solid #dddddd; /* Add an upper border */
  }

  th, td {
    border: 1px solid #dddddd; /* You can adjust the border width and color as needed */
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #F8F8F8;
  }
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/MyEncounter.vue